module.exports = __webpack_public_path__ + "img/mac-os-logo.2e8d53b4.png";